/**
 *
 */
export class Identity {
  suitableFor(role) {
    var _a, _b;

    return (_b = (_a = this.userAuthorities) === null || _a === void 0 ? void 0 : _a.includes(role)) !== null && _b !== void 0 ? _b : false;
  }

}
export class AnonymousIdentity {
  constructor() {
    this.id = '00000000-0000-0000-0000-000000000000';
  }

  suitableFor(role) {
    return false;
  }

}